import ListAllConsumersResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/list-all-consumers-response-dto";
import { IUserListSearchFilters } from "../../../shared/oversight-core/interfaces/user-list-search-filters";
import { removeNullUndefined } from "../../../shared/oversight-core/utils/removeNullUndefined";
import { transformErrorResponse } from "../../../shared/oversight-core/utils/transformErrorResponse";
import { rootApi } from "../apiManager";

export const consumerAPI = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaginatedConsumers: builder.query<
      ListAllConsumersResponseDTO,
      IUserListSearchFilters
    >({
      transformErrorResponse,
      query(params) {
        const removed = removeNullUndefined(params);
        return {
          url: `admin/customer/list`,
          method: "GET",
          params: removed,
        };
      },
      providesTags: ["Consumer"],
    }),
  }),

  overrideExisting: false,
});

export const { useGetPaginatedConsumersQuery } = consumerAPI;
